import "./Headers.css";

const SectionHeader = ({ title, subtitle }) => (
	<div className="section-header">
		<h1>{title}</h1>
	</div>
);

export default SectionHeader;
